import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'
import { Header } from 'pages/native/onBoarding/components'
import { SignupStep } from 'pages/native/onBoarding/types/types'
import { SignupContent } from './components'
import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'
import authenticationActions from 'redux-store/authentication/authentication.actions'
import { useDispatch } from 'react-redux'

export const SignUpPage = () => {
  const [currentStep, setCurrentStep] = useState(SignupStep.First)
  const history = useHistory()
  const dispatch = useDispatch()
  const { value: company } = useCompanyName()

  const headerBackHandler = () => {
    return currentStep === SignupStep.First
      ? history.goBack()
      : setCurrentStep(SignupStep.First)
  }

  const headerCurrentStepNumber = currentStep === SignupStep.First ? 3 : 4

  const onAllFormSuccess = () => {
    console.log('AUTH Registration complete, fetching session user...')
    dispatch(authenticationActions.closeLoginLayer())
    console.log('PUSH Registration complete, fetching session user...')
    history.push(`/${company}/calendar`)
  }

  return (
    <div>
      <Header
        back={headerBackHandler}
        steps={4}
        currentStep={headerCurrentStepNumber}
      />
      <SignupContent
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onLoginClick={() =>
          history.push(
            nativePublicPathGenerator(NATIVE_PUBLIC_ROUTES.AUTH.LOGIN, company)
          )
        }
        onAllFormSuccess={onAllFormSuccess}
      />
    </div>
  )
}
